const preFilters = (() => {
    // console.log('Getting HTML for PreFilters')
    let cards = document.querySelector('.CardContainerComponent')
    let html = cards.cloneNode(true)
    cards.remove()
  
    // Clean Links
    let base = window.location.href.split('?')[0].split('#')[0]
        base = (base.endsWith('/')) ? base : base + '/'

    html?.querySelectorAll('a').forEach(link => {
      let url = link.href.split('#/')[1] || link.href
      link.href = `${base}#/${url}`
    });
  
    return html.outerHTML
  })()

export default preFilters